import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { useQuery } from '../hooks/useApi';
import { Banner, EmptyState, ErrorState, Spinner } from '../components/States';
import { cleanName, dateTime } from '../lib/format';
import { useCurrency } from '../hooks/useCurrency';
import { useI18n } from '../i18n';

export function WatchlistPage() {
  const { money } = useCurrency();
  const { t } = useI18n();
  const query = useQuery(() => api.watchlist(), []);

  async function remove(templateId: number) {
    await api.removeFromWatchlist(templateId);
    query.refetch();
  }

  return (
    <>
      <div className="crumbs">
        <Link to="/">{t('app.name')}</Link>
        <span className="sep">›</span>
        <b>{t('watchlist.title')}</b>
      </div>

      {query.error && <ErrorState error={query.error} onRetry={query.refetch} />}
      {query.loading && <Spinner label={t('watchlist.loading')} />}

      {query.data && query.data.alerts.length > 0 && (
        <Banner kind="info">
          {t('watchlist.alerts', {
            n: query.data.alerts.length,
            names: query.data.alerts.map((a) => cleanName(a.name) ?? String(a.templateId)).join(', '),
          })}
        </Banner>
      )}

      {query.data && query.data.items.length === 0 && (
        <EmptyState>
          {t('watchlist.empty')}
          <br />
          {t('watchlist.emptyHint')}
        </EmptyState>
      )}

      {query.data?.items.map((item) => (
        <div className="row" key={item.id}>
          {item.iconUrl ? <img className="thumb" src={item.iconUrl} alt="" loading="lazy" /> : <div className="thumb" />}
          <div className="main">
            <div className="title">{cleanName(item.name) || `templateId ${item.templateId}`}</div>
            <div className="sub">
              {t('watchlist.addedAt', { date: dateTime(item.createdAt) })}
              {item.note ? ` · ${item.note}` : ''}
            </div>
          </div>
          <div className="right">
            <div className="price">{money(item.currentPrice)}</div>
            <div style={{ fontSize: 11, color: 'var(--muted)' }}>
              {t('watchlist.target')} {money(item.targetPrice)}{' '}
              {item.triggered && <span className="pill ok">{t('watchlist.hit')}</span>}
            </div>
          </div>
          <button className="btn ghost small" onClick={() => remove(item.templateId)}>
            {t('watchlist.remove')}
          </button>
        </div>
      ))}
    </>
  );
}
